function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, ref } from "vue";
import { definePropType } from "@types-vue/props";
import { coverOptions, validateFileSize, extractPathFromUrl } from "./index";
import CommonUploader from "@/components/Uploader/index.vue";
import { v2Host } from "@/config/host";
import { getApiPath } from "@/common/api-proxy.js";
import { Message } from "element-ui";
export default defineComponent({
    components: {
        CommonUploader: CommonUploader
    },
    props: {
        cover: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        },
        item: {
            type: definePropType(String),
            default: ""
        },
        coverGroup: {
            type: definePropType(Array),
            default: function() {
                return coverOptions;
            }
        },
        // 支持的文件类型
        accepts: {
            type: definePropType(Array),
            default: function() {
                return [
                    "jpg",
                    "jpeg",
                    "png"
                ];
            }
        },
        // 限制上传文件大小 如: 2M
        maxSize: {
            type: Number,
            default: 2
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleBeforeUpload = function handleBeforeUpload(file) {
            return validateFileSize(file, props.maxSize);
        };
        var progressUpload = function progressUpload() {
            loading.value = true;
        };
        var errorUpload = function errorUpload() {
            loading.value = false;
        };
        var loading = ref(false);
        var uploaderAttrs = {
            action: "".concat(v2Host).concat(getApiPath("/upload/file")),
            multiple: false,
            showFileList: false,
            listType: "picture-card",
            accept: props.accepts.map(function(t) {
                return ".".concat(t);
            }).join(","),
            data: {
                bucket: "mws-files",
                mod: "assets"
            },
            // @ts-ignore
            beforeUpload: handleBeforeUpload,
            onProgress: progressUpload,
            onSuccess: successUpload,
            onError: errorUpload
        };
        var cover_previews = computed(function() {
            var previewsObj = {};
            props.coverGroup.map(function(s) {
                for(var x in s.url){
                    // @ts-ignore
                    s.cover_previews[x] = extractPathFromUrl(s.url[x]);
                    // @ts-ignore
                    previewsObj[s.value] = s.cover_previews;
                }
            });
            return previewsObj;
        });
        function successUpload(response) {
            return _successUpload.apply(this, arguments);
        }
        function _successUpload() {
            _successUpload = _asyncToGenerator(regeneratorRuntime.mark(function _callee(response) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loading.value = true;
                            if (response.code === 0) {
                                // eslint-disable-next-line vue/no-mutating-props
                                props.cover.url[props.item] = response.data.url;
                                emit("previews", cover_previews.value);
                                loading.value = false;
                            } else {
                                Message.error(response.msg);
                                loading.value = false;
                            }
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _successUpload.apply(this, arguments);
        }
        return {
            loading: loading,
            cover_previews: cover_previews,
            uploaderAttrs: uploaderAttrs
        };
    }
});
